// import React, {useEffect} from 'react'
import UserLayout from '../components/UserLayout'
import RefundOrders from '../components/RefundOrders'

const RefundOrdersPage = () => {
  return (
    <UserLayout>
      <RefundOrders />
    </UserLayout>
  );
}

export default RefundOrdersPage;